import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from "@material-ui/core/Button/Button";
import ClearAll from "@material-ui/icons/ClearAll";
import FilterListIcon from "@material-ui/icons/FilterList";
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import {MOBILE_TABLE_VIEW_AMOUNT} from "../../helpers/constants";
import TablePagination from "@material-ui/core/TablePagination";
import {scrollToElement} from "../../helpers/functions";
import SortPersonsForm from './sortPersonsForm';
import _ from "lodash";

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  summaryContent: {
    flexWrap: 'wrap'
  }
});

class PersonsListMobileView extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      expanded: null,
    };

    this.personsMobileListRef = React.createRef();

  }

  componentDidMount(){
    this.props._changeLocalState({
      key: 'rowsPerPage',
      value: MOBILE_TABLE_VIEW_AMOUNT
    })
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    const { classes, persons, handleChangePage, handleChangeRowsPerPage, page, rowsPerPage } = this.props;
    const { expanded } = this.state;

    return (
      <div className={classes.root} ref={this.personsMobileListRef}>
        <Typography variant="h6" id="tableTitle">
          Persons
        </Typography>
        <div className={''}>
          <Button
            color="secondary"
            style={{paddingLeft: 0}}
            className={classes.button}
            onClick={this.props.clearFilters}
          >
            Clear filters
            <ClearAll  className={'ml-1'}/>
          </Button>
          <Button
            color="primary"
            style={{paddingLeft: 0}}
            className={classes.button}
            onClick={this.props.openFilterModal}
          >
            Filter list
            <FilterListIcon className={'ml-1'}/>
          </Button>
        </div>
        <SortPersonsForm
          {...this.props}
          initialValues={{sortBy: 'email', sortOrder: 'asc'}}
        />
        {
          _.orderBy(persons, item => {
            if(this.props.mobileViewSortBy === 'username') {return item.username}
            if(this.props.mobileViewSortBy === 'email') {return item.email}
            if(this.props.mobileViewSortBy === 'department') {return item.department?item.department.name:''}
            if(this.props.mobileViewSortBy === 'role') {return  item.roles[0]? item.roles[0].name : ''}
          }, this.props.mobileViewSortOrder)
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map(person => {
            return (
              <ExpansionPanel
                key={person.id}
                expanded={expanded === person.id}
                onChange={this.handleChange(person.id)}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{content: classes.summaryContent}}>
                  <Typography className={classes.heading}>{person.username}</Typography>
                  <Typography className={classes.secondaryHeading}>
                    {person.department?person.department.name: ''}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Table >
                    <TableBody>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Username'}</TableCell>
                        <TableCell>{person.username}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Email'}</TableCell>
                        <TableCell>{person.email}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Role'}</TableCell>
                        <TableCell>
                          {
                            person.roles[0]?
                              person.roles[0].name
                              :
                              ''
                          }
                        </TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Department'}</TableCell>
                        <TableCell> {person.department?person.department.name: ''}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </ExpansionPanelDetails>
                <ExpansionPanelActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={() => this.props.history.push('/person/' + person.id)}
                  >
                    {'Edit'}
                  </Button>
                  {this.props.loggedInPersonId !== person.id && (
                    <Button
                      size="small"
                      color="secondary"
                      onClick={() => this.props._openDeleteModal(person)}
                    >
                      {'Delete'}
                    </Button>
                  )}
                </ExpansionPanelActions>
              </ExpansionPanel>
            )
          })
        }
        <TablePagination
          classes={
            {
              root: classes.pager,
              toolbar: classes.pagerToolbar
            }
          }
          rowsPerPageOptions={[]}
          labelRowsPerPage={''}
          component="div"
          count={persons.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={(evt, page) => {
            scrollToElement(this.personsMobileListRef.current);
            handleChangePage(evt, page);
          }}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

PersonsListMobileView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PersonsListMobileView);



// WEBPACK FOOTER //
// ./src/components/personsList/personsListMobileView.js